import request from "@/utils/request";


/**
 *  集合页列表
 * @param {*}
 * @returns {}
 */
 export function getEventCollection(params) {
  return request({
    url: "/getEventCollection",
    method: "GET",
    params,
  });
}

/**
 *  直播列表
 * @param {*}
 * @returns {}
 */
export function getLiveList(params) {
  return request({
    url: "/getLiveList",
    method: "GET",
    params,
  });
}

/**
 *  直播详情
 * @param {*}  id
 * @returns {}
 */
export function getLive(params) {
  return request({
    url: "/getLive",
    method: "GET",
    params,
  });
}


/**
 * 直播订阅
 * @data {*} live_id 直播id
 * @returns
 */
 export function reservationLive(data) {
  return request({
    url: "/reservationLive",
    method: "POST",
    data,
  });
}

/**
 * 创建直播订单
 * @data {*} live_id 直播id
 * @returns
 */
 export function createLiveOrder(data) {
  return request({
    url: "/createLiveOrder",
    method: "POST",
    data,
  });
}

/**
 * 创建直播订单
 * @data {*} order_id 订单id
 * @returns
 */
 export function cancelLiveOrder(data) {
  return request({
    url: "/cancelLiveOrder",
    method: "POST",
    data,
  });
}

/**
 * 创建直播订单
 * @data {*} order_id 订单id
 * @data {*} cdk
 * @returns
 */
 export function cdkRelayOrderPay(data) {
  return request({
    url: "/cdkRelayOrderPay",
    method: "POST",
    data,
  });
}


/**
 * 获取直播订单列表
 * @params {} 
 * @returns
 */
export function getLiveOrderList(params) {
  return request({
    url: "/getLiveOrderList",
    method: "GET",
    params,
  });
}


/**
 * 微信支付信息
 * @params {} order_id 订单id
 * @returns
 */
 export function getLiveWxPay(params) {
  return request({
    url: "/getLiveWxPay",
    method: "GET",
    params,
  });
}


/**
 * 获取峰会直播支付宝支付
 * @params {} order_id 订单id
 * @returns
 */
 export function getLiveAliPay(params) {
  return request({
    url: "/getLiveAliPay",
    method: "GET",
    params,
  });
}


/**
 * 获取峰会直播支付宝支付
 * @params {} order_id 订单id
 * @returns
 */
export function checkLivePay(params) {
  return request({
    url: "/checkLivePay",
    method: "GET",
    params,
  });
}



/**
 * 峰会直播赠票订单列表
 * @returns
 */
 export function getRelayGiveList(params) {
  return request({
    url: "/getRelayGiveList",
    method: "GET",
    params,
  });
}


/**
 * 获取观众赠票峰会直播详情
 * @params {} give_id
 * @returns
 */
 export function getRelayGiveInfoList(params) {
  return request({
    url: "/getRelayGiveInfoList",
    method: "GET",
    params,
  });
}


/**
 * 获取观众赠票峰会直播
 * @params {} give_id
 * @returns
 */
 export function getVisitorRelayGive(params) {
  return request({
    url: "/getVisitorRelayGive",
    method: "GET",
    params,
  });
}


/**
 * 领取观众赠赠票直播
 * @data {} give_id 
 * @data {} receive_code 
 * @returns
 */
 export function receiveVisitorRelayGive(data) {
  return request({
    url: "/receiveVisitorRelayGive",
    method: "POST",
    data,
  });
}

/**
 * 获取直播订阅列表
 * @params {} status: 是否提醒 1是 0否  默认-1所有
 * @returns
 */
 export function getLiveReservationList(params) {
  return request({
    url: "/getLiveReservationList",
    method: "GET",
    params,
  });
}




/**
 * 线下峰会列表
 * @params {url} 
 * @returns
 */
export function getEventList(params) {
  return request({
    url: "/getEventList",
    method: "GET",
    params,
  });
}


/**
 * 线下峰会
 * @params {url} 
 * @returns
 */
 export function getEvent(params) {
  return request({
    url: "/getEvent",
    method: "GET",
    params,
  });
}

/**
 * 线下峰会创建订单
 * @params {url} 
 * @returns
 */
 export function createEventTicket(data) {
  return request({
    url: "/createEventTicket",
    method: "POST",
    data,
  });
}


/**
 * 线下峰会订单列表
 * @params {} 
 * @returns
 */
 export function getTicketList(params) {
  return request({
    url: "/getTicketList",
    method: "GET",
    params,
  });
}

/**
 * 检查优惠购物码是否可用
 * @data {coupon_num} 优惠码
 * @returns
 */
 export function checkEventCoupon(data) {
  return request({
    url: "/checkEventCoupon",
    method: "POST",
    data,
  });
}



/**
 * 门票列表
 * @params {} expo_area_id 展会id
 * @returns
 */
 export function getTicketInfoList(params) {
  return request({
    url: "/getTicketInfoList",
    method: "GET",
    params,
  });
}



/**
 * 微信支付信息
 * @params {} ticket_id 订单id
 * @returns
 */
 export function getTicketWxPay(params) {
  return request({
    url: "/getTicketWxPay",
    method: "GET",
    params,
  });
}




/**
 * 取消订单
 * @data {} ticket_id 订单id
 * @returns
 */
 export function cancelTicket(data) {
  return request({
    url: "/cancelTicket",
    method: "POST",
    data,
  });
}


/**
 * 获取支付信息
 * @params {} ticket_id 订单id
 * @returns
 */
 export function getTicketPay(params) {
  return request({
    url: "/getTicketPay",
    method: "GET",
    params,
  });
}


/**
 * 线下支付
 * @data {} ticket_id 订单id
 * @returns
 */
 export function offlineTicketPayment(data) {
  return request({
    url: "/offlineTicketPayment",
    method: "POST",
    data,
  });
}



/**
 * 支付宝支付
 * @params {} ticket_id 订单id
 * @returns
 */
 export function getTicketAliPay(params) {
  return request({
    url: "/getTicketAliPay",
    method: "GET",
    params,
  });
}


/**
 * 微信支付
 * @data {} ticket_id 订单id
 * @returns
 */
 export function ticketWxCallback(data) {
  return request({
    url: "/ticketWxCallback",
    method: "POST",
    data,
  });
}


/**
 * 检查订单支付状态
 * @params {} ticket_id 订单id
 * @returns
 */
 export function checkTicketPay(params) {
  return request({
    url: "/checkTicketPay",
    method: "GET",
    params,
  });
}



/**
 * 线下峰会赠票订单列表
 * @returns
 */
 export function getTicketGiveList(params) {
  return request({
    url: "/getTicketGiveList",
    method: "GET",
    params,
  });
}




/**
 * 领取赠送线下峰会门票
 * @data {} give_id 订单id
 * @data {} receive_code 
 * @returns
 */
 export function receiveVisitorTicketGive(data) {
  return request({
    url: "/receiveVisitorTicketGive",
    method: "POST",
    data,
  });
}



/**
 * 获取线下峰会赠票详情 
 * @params {} ticket_id 订单id
 * @returns
 */
 export function getTicketGiveInfo(params) {
  return request({
    url: "/getTicketGiveInfo",
    method: "GET",
    params,
  });
}


/**
 * 领取门票信息
 * @params {} ticket_id 订单id
 * @returns
 */
 export function getVisitorTicketGive(params) {
  return request({
    url: "/getVisitorTicketGive",
    method: "GET",
    params,
  });
}



/**
 * 领取门票信息
 * @params {} ticket_id 订单id
 * @returns
 */
 export function getCategoryTreeList(params) {
  return request({
    url: "/getCategoryTreeList",
    method: "GET",
    params,
  });
}






/**
 * 获取发票列表
 * @params {} source_type 发票类型 1线下峰会 2直播
 * @returns
 */
 export function getInvoiceList(params) {
  return request({
    url: "/getInvoiceList",
    method: "GET",
    params,
  });
}

/**
 * 获取发票订单(未开发票数据)
 * @params {} source_type 发票类型 1线下峰会 2直播
 * @params {} id 订单id
 * @returns
 */
 export function getInvoiceOrder(params) {
  return request({
    url: "/getInvoiceOrder",
    method: "GET",
    params,
  });
}

/**
 * 获取发票详情
 * @params {} source_type 发票类型 1线下峰会 2直播
 * @params {} id 订单id
 * @returns
 */
 export function getInvoice(params) {
  return request({
    url: "/getInvoice",
    method: "GET",
    params,
  });
}


/**
 * 发票申请
 * @returns
 */
 export function invoiceApply(data) {
  return request({
    url: "/invoiceApply",
    method: "POST",
    data,
  });
}


/**
 * 删除发票
 * id
 * @returns
 */
 export function delInvoice(data) {
  return request({
    url: "/delInvoice",
    method: "POST",
    data,
  });
}




/**
 * 绑定万能门票
 * 
 * @returns
 */
export function bindTicketCommonGive(data) {
  return request({
    url: "/bindTicketCommonGive",
    method: "POST",
    data,
  });
}

/**
 * 检查优惠码是否可以使用
 * @params {} receive_code 领票码
 * @returns
 */
export function checkTicketCommonGiveReceiveCode(params) {
  return request({
    url: "/checkTicketCommonGiveReceiveCode",
    method: "GET",
    params,
  });
}

/**
 * 获取绑定万能码列表
 * @params {} status 状态 1已绑定  2已兑换
 * @returns
 */
export function getTicketCommonGiveList(params) {
  return request({
    url: "/getTicketCommonGiveList",
    method: "GET",
    params,
  });
}

/**
 * 兑换万能票
 * id
 * @returns
 */
export function receiveTicketCommonGive(data) {
  return request({
    url: "/receiveTicketCommonGive",
    method: "POST",
    data,
  });
}
